<script>
// import Layout from '@layouts/Main'

export default {
  page: {
    title: 'Page timeout',
    meta: [
      {
        name: 'description',
        content: 'The page timed out while loading.',
      },
    ],
  },
  beforeDestroy() {
    var doc = this.$refs.timeout
    if (doc !== undefined) doc.innerHTML = ''
  },
  //  components: { Layout },
}
</script>

<template>
  <section ref="timeout">
    <div class="container">
      <div
        :class="$style.rowAlign"
        class="row align-items-center justify-content-center"
      >
        <div class="col-12">
          <div :class="$style.timeoutWraper">
            <div :class="$style.timer">
              <img src="@assets/images/timer.png" alt="Timeout" />
              <span :class="$style.needle"></span>
            </div>
            <h4>504</h4>
            <h3>Gate way timeout error..!</h3>
            <p :class="$style.title"
              >The page timed out while loading. Are you sure you're still
              connected to the Internet?</p
            >
          </div>
        </div>
      </div>
    </div>
    <!-- <h1 :class="$style.title">
            The page timed out while loading. Are you sure you're still connected to
            the Internet?
        </h1> -->
  </section>
</template>

<style lang="scss" module>
@import '@design';

.title {
  margin: 20px 0;
  font-family: 'SourceSansProSemiRegular', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 20px;
  color: $primary-font-color;
  text-align: center;
}

.rowAlign {
  height: 100vh;
}

.timer {
  position: relative;
  width: 300px;
  margin: 0 auto;
  transform: scale(0.8);
  animation: shake 0.2s;

  &::after {
    position: absolute;
    top: 177px;
    left: 137px;
    width: 29px;
    height: 29px;
    content: '';
    background: #5d7979;
    border-radius: 50px;
  }

  img {
    width: 100%;
  }

  .needle {
    position: absolute;
    top: 189px;
    right: 87px;
    width: 63px;
    height: 11px;
    background: #01445c;
    border-radius: 50px;
    transform-origin: 0;
    animation-name: spin;
    animation-duration: 3s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }
}

.timeoutWraper {
  h4 {
    margin: 0;
    font-size: 100px;
    font-weight: bold;
    line-height: 100px;
    color: #f76b78;
    text-align: center;
  }

  h3 {
    margin: 0;
    font-size: 50px;
    font-weight: bold;
    line-height: 50px;
    color: #f7936b;
    text-align: center;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 767px) {
  .timeoutWraper {
    h4 {
      font-size: 50px;
      line-height: 50px;
    }

    h3 {
      font-size: 20px;
      line-height: 20px;
    }
  }

  .title {
    margin: 5px;
    font-size: 15px;
  }

  .timer {
    width: 200px;

    &::after {
      top: 119px;
      left: 91px;
      width: 18px;
      height: 18px;
    }

    .needle {
      top: 124px;
      right: 62px;
      width: 40px;
      height: 8px;
    }
  }
}
</style>
